import React from "react";
import {
  Table,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
// import './SearchBar.css';
import OverlayLoading from "./OverlayLoading.jsx";
import { formatPhoneNumber } from "../../utils/tools";
import IconEllipsis from "../Icon/Ellipsis.jsx";

class DataTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // render each row details
  createRow = (row) => {
    let keys = Object.keys(row);

    return keys.map((key) => {
      return <td key={key}>{row[String(key)]}</td>;
    });
  };

  render() {
    const heads = this.props.heads;
    const dataAttributes = this.props.dataAttributes;
    const cols = heads.map((head) => (
      <th scope="col" key={head}>
        {head}
      </th>
    ));

    const rows = this.props.rows;
    const data = rows.map((row) => (
      <tr key={row.id}>
        {dataAttributes.map(function (attribute) {
          if (attribute === "role") {
            return (
              <td
                key={`user-${row.id}-${attribute}`}
              >{`${row["role"]["display_name"]}`}</td>
            );
          } else if (attribute === "phone") {
            return (
              <td key={`user-${row.id}-${attribute}`}>
                {row["phone"] ? formatPhoneNumber(row["phone"]) : "N/A"}
              </td>
            );
          } else {
            return (
              <td key={`user-${row.id}-${attribute}`}>{`${row[attribute]}`}</td>
            );
          }
        })}
        <td className="ml-auto" style={{ maxWidth: "50px" }}>
          <UncontrolledDropdown>
            <DropdownToggle
              className="btn-icon-only text-light"
              href="#pablo"
              role="button"
              size="sm"
              color=""
              onClick={(e) => e.preventDefault()}
            >
              <IconEllipsis className="size-5" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.changeRole(row);
                }}
              >
                更改身份
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
    ));

    return (
      <OverlayLoading loading={this.props.loading}>
        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
            <tr>{cols}</tr>
          </thead>
          <tbody>{data}</tbody>
        </Table>
      </OverlayLoading>
    );
  }
}

export default DataTable;
